import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

/**
 * Генератор хранилища ядра
 * @param reducer
 */
export const BCoreStore = (reducer: any) => configureStore({
  reducer: { ...reducer },
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    })
  ],
});
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';

/**
 * Генератор хранилища ядра
 * @param reducer
 */
export const BCoreStore = (reducer: any) => configureStore({
  reducer: { ...reducer },
  middleware: [
    ...getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    })
  ],
});
